"use client";

import type React from "react";
import { useState } from "react";
import {
  FormControl,
  FormLabel,
  Text,
  Switch,
  HStack,
  Box,
  IconButton,
  Tooltip,
} from "@chakra-ui/react";
import { InfoIcon } from "@chakra-ui/icons";

interface SpeechNormalizationToggleProps {
  value: boolean | undefined;
  onChange: (value: boolean) => Promise<boolean> | void;
}

export const SpeechNormalizationToggle: React.FC<
  SpeechNormalizationToggleProps
> = ({ value = false, onChange }) => {
  const [isUpdating, setIsUpdating] = useState(false);

  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsUpdating(true);
    try {
      await onChange(e.target.checked);
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <FormControl>
      <HStack justify="space-between" align="flex-start">
        <Box>
          <HStack align="center" mb={1} spacing={1}>
            <FormLabel
              fontSize="sm"
              fontWeight="medium"
              color="gray.700"
              mb={0}
            >
              Enable Speech Normalization
            </FormLabel>
            <Tooltip
              label="Converts text elements to their spoken form for better speech synthesis"
              placement="top"
            >
              <IconButton
                aria-label="Info"
                icon={<InfoIcon boxSize={3} />}
                size="xs"
                variant="ghost"
                color="gray.600"
                _hover={{ bg: "gray.100" }}
              />
            </Tooltip>
          </HStack>

          <Text fontSize="xs" color="gray.600">
            It converts text elements like numbers, currency, and dates into
            human-like spoken forms.
            {/* <Link href="https://docs.retellai.com/build/speech-controllability" isExternal color="gray.600">
              Learn more <ExternalLinkIcon mx="2px" />
            </Link> */}
          </Text>
        </Box>

        <Switch
          isChecked={value}
          onChange={handleChange}
          isDisabled={isUpdating}
          colorScheme="primary"
        />
      </HStack>
    </FormControl>
  );
};
